import { TextToSubscribeDescriptionElement } from "@redotech/redo-model/content-builder/element-schema";
import { SUBSCRIBE_DESCRIPTION } from "@redotech/redo-model/signup-form";
import { memo } from "react";
import { FormElementProps } from "./index";

export const TextToSubscribeDescription = memo(
  function TextToSubscribeDescription({
    element,
    merchantName,
  }: Pick<
    FormElementProps<TextToSubscribeDescriptionElement>,
    "element" | "merchantName"
  >) {
    return (
      <div
        style={{
          fontFamily: element.fontFamily,
          color: element.textColor,
          fontSize: "8px",
        }}
      >
        {SUBSCRIBE_DESCRIPTION}
      </div>
    );
  },
);
